/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { useTranslations } from 'next-intl'
import React from 'react'

import { FilterSelect } from '@/components/quality-explorer/FilterSelect'
import { ActivityFilter, Kit } from '@/components/quality-explorer/types'
import { Typography } from '@/components/ui/Typography'

/** A description of the available properties for this component. */
type ActivityFiltersProps = {
  /** The current filter values. */
  filters: ActivityFilter

  /** The available kits to filter by. */
  kits: Array<Kit>

  /** A function to call when a filter changes. */
  onFilterChange: (key: keyof ActivityFilter, value: string) => void
}

/**
 * A set of filters for activities in the qualities explorer.
 */
const ActivityFilters: React.FC<ActivityFiltersProps> = ({ filters, kits, onFilterChange }) => {
  const t = useTranslations('ActivityFilters')

  return (
    <div className={'px-2'}>
      <Typography variant={'h3'} colour={'primary'} weight={'semibold'} className={'mb-4'} align={'center'}>
        {t('relatedActivities')}
      </Typography>
      <Typography variant={'h4'} colour={'primary'} weight={'normal'} className={'mb-6'} align={'center'}>
        {t('relatedActivitiesTagline')}
      </Typography>

      <div className={'flex flex-col gap-2 items-center justify-center sm:flex-row sm:flex-wrap'}>
        <FilterSelect
          label={t('product')}
          value={filters.product}
          onChange={(value) => onFilterChange('product', value)}
        >
          <option value={''}>{t('product')}</option>
          {kits?.map((kit) => (
            <option key={kit.id} value={kit.code}>
              {kit.name}
            </option>
          ))}
        </FilterSelect>

        <FilterSelect
          label={t('duration')}
          value={filters.duration}
          onChange={(value) => onFilterChange('duration', value)}
        >
          <option value={''}>{t('duration')}</option>
          <option value={'short'}>{t('short')}</option>
          <option value={'long'}>{t('long')}</option>
        </FilterSelect>

        <FilterSelect
          label={t('complexity')}
          value={filters.complexity}
          onChange={(value) => onFilterChange('complexity', value)}
        >
          <option value={''}>{t('complexity')}</option>
          <option value={'1'}>{t('introductory')}</option>
          <option value={'2'}>{t('intermediate')}</option>
          <option value={'3'}>{t('advanced')}</option>
        </FilterSelect>

        <FilterSelect label={t('type')} value={filters.dora} onChange={(value) => onFilterChange('dora', value)}>
          <option value={''}>{t('type')}</option>
          <option value={'development'}>{t('development')}</option>
          <option value={'assessment'}>{t('assessment')}</option>
        </FilterSelect>
      </div>
    </div>
  )
}

export { ActivityFilters }
